/* eslint-disable import/order */
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { getGlobalPermissionPageResources } from '@jira/router-resources__advanced-roadmaps-settings/src/getGlobalPermissionPageResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { arjSettingsPermissionsRoute } from '@jira/router-routes__advanced-roadmaps-settings-routes/src/arjSettingsPermissionsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ArjSettingsPermissions, LazyArjSettingsPermissions } from './ui/index.tsx';

export const arjSettingsPermissionsRouteEntry: Route = createEntry(
	arjSettingsPermissionsRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: ArjSettingsPermissions,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			...getGlobalPermissionPageResources(),
		],

		forPaint: [LazyAtlassianNavigation, LazyArjSettingsPermissions],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
